module.exports = __webpack_public_path__ + "img/blank_page.7d9726d8.png";